/* eslint-disable */
import * as React from "react";
import { last, first } from "lodash";
import { ReportToolbar, ReportToolbarGroup, ReportToolbarSpacer, ReportToolbarNumber } from "../../components/ReportToolbar";
import { ReportGrid } from "../../components/ReportGrid";
import { ReportLayout } from "../../components/ReportLayout";
import { ReportHeader } from "../../components/ReportHeader";
import { ReportContainer } from "../../components/ReportContainer";
import { ReportRenderer, useParameter } from "../../shared";
import { CalendarControl } from "./controls/CalendarControl";
import { CommoditiesControl } from "./controls/CommoditiesControl";
import { BusinessUnitControl } from "./controls/BusinessUnitControl";
import { useExportQuery } from "./export/useExportQuery";
import { useFavourite } from "./favourite/useFavourite";
import { useSubscription } from "./subscription/useSubscription";
import { useResetBusinessUnit } from "./hooks/useResetBusinessUnit";
import { useSlideSubtitle } from "./hooks/useSlideSubtitle";
import { useSlideTitle } from "./hooks/useSlideTitle";
import { useDescription } from "./hooks/useDescription";

export default function (props: { exportMode?: boolean }) {
  const { exportMode } = props;
  useResetBusinessUnit();
  const [business] = useParameter<number>("@business-units");
  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  useExportQuery(title, subtitle);
  const { isFavouriteLoading } = useFavourite();
  useSubscription();
  const description = useDescription();

  return (
    <ReportContainer>
      <ReportHeader title={title} subtitle={subtitle} description={description} exportMode={exportMode} />
      <ReportToolbar exportMode={exportMode}>
        <ReportToolbarGroup isLoading={isFavouriteLoading}>
          <BusinessUnitControl />
          <CommoditiesControl key={business || undefined} />
          <CalendarControl />
        </ReportToolbarGroup>
        <ReportToolbarSpacer />
        <ReportToolbarNumber number={3} />
      </ReportToolbar>
      <ReportLayout>
        <ReportGrid>
          <ReportRenderer componentId="chart-area-production-yield" />
        </ReportGrid>
      </ReportLayout>
    </ReportContainer>
  );
}
